// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/login-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-side {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #002133;
}
.secondary_text {
  width: 95% !important;
  font-size: 16px !important;
}
.logo_padding {
  padding: 50px !important;
}
.logo_padding_forgot_password {
  padding: 50px 50px 20px !important;
}
.login-form-pad-desktop {
  width: 40% !important;
  padding-top: 13% !important;
}
.login-form-pad-desktop-step-2 {
  width: 40% !important;
  padding-top: 5% !important;
}
.login-form-pad-p-and-g {
  width: 40% !important;
}
.login-form-pad-mobile {
  width: 60% !important;
  padding-top: 13% !important;
}
.login-form-pad-mobile-step-2 {
  width: 60% !important;
  padding-top: 5% !important;
}
.fs-14 {
  font-size: 14px !important;
}
.fs-13 {
  font-size: 13px !important;
}
.fs-12 {
  font-size: 12px !important;
}
.fs-error {
  font-size: small;
}
.next-button {
  background-color: #000e0f;
  border: 0px solid transparent;
  border-radius: 4px;
}
.username {
  border: 0px solid transparent;
  border-bottom: 1px solid gray;
  border-radius: 0px;
}
.username.change-password {
  border-bottom: unset;
}
.username .p-icon-field {
  width: 100% !important;
}
.username .p-icon-field .p-password-input {
  width: 100% !important;
  border: 0px solid transparent !important;
  font-family: "Montserrat";
}
.username.change-password .p-icon-field .p-password-input {
  border: 1px solid #ced4da !important;
}
.change-password .p-icon-field > .p-input-icon {
  top: 40%;
}
.password-input .p-password-input {
  width: 100% !important;
}
.password-input .p-password-input.p-inputtext:enabled:focus {
  border: 1px solid #ced4da !important;
}
.password-input .p-password-input.p-inputtext:enabled:hover {
  border: 1px solid #ced4da !important;
}
.password-input.error-input {
  border: 1px solid #dc3545 !important;
  border-radius: 3px;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 0.2rem transparent !important;
}

.captcha-display {
  text-align: center;
  margin-top: 10px;
  background-color: #f1f1f1;
}

.forgot-password {
  color: #2196f3;
  font-weight: 600;
  cursor: pointer;
}
.read-terms {
  color: #616161;
}
.decoration {
  text-decoration: none;
  color: #2196f3;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;EACE,yDAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,QAAQ;AACV;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".left-side {\n  background-image: url(\"../images/login-bg.jpg\");\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-color: #002133;\n}\n.secondary_text {\n  width: 95% !important;\n  font-size: 16px !important;\n}\n.logo_padding {\n  padding: 50px !important;\n}\n.logo_padding_forgot_password {\n  padding: 50px 50px 20px !important;\n}\n.login-form-pad-desktop {\n  width: 40% !important;\n  padding-top: 13% !important;\n}\n.login-form-pad-desktop-step-2 {\n  width: 40% !important;\n  padding-top: 5% !important;\n}\n.login-form-pad-p-and-g {\n  width: 40% !important;\n}\n.login-form-pad-mobile {\n  width: 60% !important;\n  padding-top: 13% !important;\n}\n.login-form-pad-mobile-step-2 {\n  width: 60% !important;\n  padding-top: 5% !important;\n}\n.fs-14 {\n  font-size: 14px !important;\n}\n.fs-13 {\n  font-size: 13px !important;\n}\n.fs-12 {\n  font-size: 12px !important;\n}\n.fs-error {\n  font-size: small;\n}\n.next-button {\n  background-color: #000e0f;\n  border: 0px solid transparent;\n  border-radius: 4px;\n}\n.username {\n  border: 0px solid transparent;\n  border-bottom: 1px solid gray;\n  border-radius: 0px;\n}\n.username.change-password {\n  border-bottom: unset;\n}\n.username .p-icon-field {\n  width: 100% !important;\n}\n.username .p-icon-field .p-password-input {\n  width: 100% !important;\n  border: 0px solid transparent !important;\n  font-family: \"Montserrat\";\n}\n.username.change-password .p-icon-field .p-password-input {\n  border: 1px solid #ced4da !important;\n}\n.change-password .p-icon-field > .p-input-icon {\n  top: 40%;\n}\n.password-input .p-password-input {\n  width: 100% !important;\n}\n.password-input .p-password-input.p-inputtext:enabled:focus {\n  border: 1px solid #ced4da !important;\n}\n.password-input .p-password-input.p-inputtext:enabled:hover {\n  border: 1px solid #ced4da !important;\n}\n.password-input.error-input {\n  border: 1px solid #dc3545 !important;\n  border-radius: 3px;\n}\n.p-inputtext:enabled:focus {\n  outline: 0 none !important;\n  outline-offset: 0 !important;\n  box-shadow: 0 0 0 0.2rem transparent !important;\n}\n\n.captcha-display {\n  text-align: center;\n  margin-top: 10px;\n  background-color: #f1f1f1;\n}\n\n.forgot-password {\n  color: #2196f3;\n  font-weight: 600;\n  cursor: pointer;\n}\n.read-terms {\n  color: #616161;\n}\n.decoration {\n  text-decoration: none;\n  color: #2196f3;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
